import { FC } from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';

import Text from 'components/_core/Text';

import locales from './locales';

const SelectedOfferTag: FC<FlexProps> = (props) => (
  <Flex
    alignItems="center"
    backgroundColor="grey.800"
    borderRadius="full"
    height="space-24"
    paddingX="space-8"
    {...props}
  >
    <Text color="white" fontWeight="weight-500" size="xs">
      {locales.selectedOffer}
    </Text>
  </Flex>
);

export default SelectedOfferTag;
